export const brightBlue = "#505CC9";
export const darkBlue = "#545CA8";
export const softGrey = "#DBDBDB";
export const mediumGrey = "#C9C9C9";
export const grey = "#6E6E6E";
export const darkGrey = "#434343";
export const black = "#222222";
export const white = "#FFFFFF";
